module.exports = __webpack_public_path__ + "static/img/relief02.f0470d2.bmp";


//////////////////
// WEBPACK FOOTER
// ./src/views/papercutLamp/imgs/relief02.bmp
// module id = wLtV
// module chunks = 2